import { CourseMaterial } from "./coursesLoader";

export default function hasInstructions({
  attachments,
  displayNotes,
}: Pick<CourseMaterial, "attachments" | "displayNotes">) {
  if (!!displayNotes || (attachments && attachments.length > 0)) {
    return true;
  } else {
    return false;
  }
}
